import React from "react";

function SkeletonBar({ width, height = 12, style = {} }) {
  return (
    <div
      className="sk-bar"
      style={{ width, height, borderRadius: 6, ...style }}
    />
  );
}

function SkeletonTimerRow() {
  return (
    <div className="in-timer-project-panel-action-row project-full-description-row sk-timer-row">
      <div className="inner-project-action-contain" style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 16px" }}>
        {/* Description */}
        <SkeletonBar width="28%" />

        {/* Project */}
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <div className="sk-bar" style={{ width: 14, height: 14, borderRadius: 3 }} />
          <SkeletonBar width={80} />
        </div>

        {/* Tag */}
        <SkeletonBar width={60} height={10} style={{ borderRadius: 10 }} />

        {/* Spacer */}
        <div style={{ flex: 1 }} />

        {/* Time range */}
        <SkeletonBar width={100} height={10} />

        {/* Duration */}
        <SkeletonBar width={52} height={14} style={{ borderRadius: 4 }} />

        {/* 3-dot */}
        <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {[0, 1, 2].map((i) => (
            <div key={i} className="sk-bar" style={{ width: 4, height: 4, borderRadius: "50%" }} />
          ))}
        </div>
      </div>
    </div>
  );
}

function SkeletonDayGroup({ rows = 3 }) {
  return (
    <div className="in-timer-project-panel">
      {/* Day header */}
      <div className="in-timer-project-panel-action-row">
        <div className="inner-project-action-contain" style={{ display: "flex", alignItems: "center", padding: "8px 16px" }}>
          <SkeletonBar width={90} height={11} />
          <div style={{ flex: 1 }} />
          <SkeletonBar width={52} height={11} />
        </div>
      </div>

      {/* Timer rows */}
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonTimerRow key={i} />
      ))}
    </div>
  );
}

export default function TimerListSkeleton({ groups = 2 }) {
  return (
    <div className="sk-timer-list">
      {Array.from({ length: groups }).map((_, i) => (
        <SkeletonDayGroup key={i} rows={i === 0 ? 3 : 2} />
      ))}
    </div>
  );
}
